<script>
import DashboardLayout from '@/components/layouts/dashboard/DashboardLayout';
import TemplateForm from '@/components/templates/TemplateForm';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'NewTemplate',
  components: {
    DashboardLayout,
    TemplateForm
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('New Template'),
      breadcrumbs: [{ text: this.$t('Sites'), to: { name: 'Sites' } }, { text: this.$t('New Template') }],
      invalid: [],
      isDisabled: false,
      isSaving: false,
      site: {},
      statusCode: null,
      template: {}
    };
  },
  created() {
    // Fetch initial data
    this.$http
      .get(`/sites/${this.$route.params.siteId}`)
      .then(res => {
        this.site = res.data.site;
        this.breadcrumbs = [
          { text: this.$t('Sites'), to: { name: 'Sites' } },
          { text: this.site.name, to: { name: 'Site', params: { siteId: this.site.id } } },
          { text: this.$t('Manage Templates'), to: { name: 'Templates', params: { siteId: this.site.id } } },
          { text: this.$t('New Template') }
        ];
        this.statusCode = 200;
        this.$nextTick(() => {
          this.$refs.templateForm.resetCleanState();
          this.$refs.templateForm.$refs.name.focus();
        });
      })
      .catch(err => (this.statusCode = err.response.status));
  },
  beforeRouteLeave(to, from, next) {
    // Check for unsaved changes
    if (this.$refs.templateForm.isDirty()) {
      this.$confirm(this.$t("Your changes haven't been saved. Are you sure you want to continue?"), {
        title: this.$t('Unsaved Changes'),
        confirmButtonText: this.$t('Continue'),
        cancelButtonText: this.$t('Cancel')
      }).then(() => next());
    } else {
      next();
    }
  },
  methods: {
    // Cancels all changes and goes back to the templates page
    handleCancel() {
      this.$router.push({ name: 'Templates', params: { siteId: this.site.id } });
    },

    // Saves the template
    handleSave() {
      const data = this.$refs.templateForm.getData();
      this.isSaving = true;
      this.$http
        .post(`/sites/${this.site.id}/templates`, data)
        .then(res => {
          this.invalid = [];
          this.template = res.data.template;
          this.$refs.templateForm.resetCleanState();
          this.$router.push({ name: 'Templates', params: { siteId: this.site.id } });
        })
        .catch(err => {
          const data = err.response.data;
          this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
          this.$notify({
            type: 'error',
            title: this.$t('Error'),
            message: getErrorMessage(err.response.data.code)
          });
        })
        .finally(() => (this.isSaving = false));
    }
  }
};
</script>

<template>
  <dashboard-layout :status-code="statusCode" size="small">
    <!-- Breadcrumbs -->
    <template slot="breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="item.to">
          {{ item.text }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <!-- Template form -->
    <template-form
      ref="templateForm"
      :disabled="isDisabled"
      :invalid="invalid"
      :saving="isSaving"
      is-new
      @cancel="handleCancel"
      @submit="handleSave"
    />
  </dashboard-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
</style>
